"use strict";

import 'url-search-params-polyfill'; // Edge Polyfill
import {createAjaxForm} from '@elements/ajax-form';
import { findIn } from '@elements/dom-utils'
import axios from 'axios';
import formDataEntries from 'form-data-entries';

const defaultSelectors = {
    base: '.js-ajax-form-map',
    result: '.js-ajax-form-map__result',
    loading: '.js-ajax-form-map__loading',
    notifications: '.js-ajax-form-map__notifications',
    form: '.js-ajax-form-map__form',
    additionalForm: '.js-ajax-form-map__additional-form',
    errorArea: '.js-ajax-form-map__error-area',
    retry: '.js-ajax-form-map__retry',
    link: '.js-ajax-form-map__link'
};

export const createInitAjaxFormMap =({createMap, getApi}) => {
    return function (form, options, selectors = defaultSelectors) {
        let formObj = {
            mapObj: createMap(options.element, options),
            element: form,
            formApi: createAjaxForm(form, {
                onSubmit: x => fetchPois()
            }, selectors)
        };

        getApi(options.element).then((api) => {
            fetchPois(api);
        })

        async function fetchPois(api) {
            if(!api){
                api = await getApi(options.element);
            }

            axios({
                method: 'GET',
                url: formObj.element.dataset.formMapUrl,
                headers: {
                    ajax: 1,
                    'pragma': 'no-cache',
                    'cache-control': 'no-cache',
                    'X-Requested-With': 'XMLHttpRequest',
                    ...options.fetchHeaders
                },
                params: new URLSearchParams(formDataEntries(findIn('form', form)))
            }).then((res) => {
                if (res.data.success) {
                    api.setMarker(res.data.pois);
                }
            }).catch((error) => {
                console.error("loading data-form-map-url failed:" + error);
            });

        }

        return formObj;
    }
};